import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../Partial/Header';
import Footer from '../Partial/Footer';
import { BASE_URL } from '../config';
import { useParams } from 'react-router-dom';
import { toast } from 'material-react-toastify';
import LoaderOverlay from '../Partial/LoaderOverlay';

const ContactUs = () => {
    const { productFlag } = useParams();
    const { capName } = useParams();
    const [loading, setLoading] = useState(true);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const [error, setError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [contactInfo, setContactInfo] = useState({
        address: '',
        phone: '',
        email: ''
    });

    // useEffect(() => {
    //     if (productFlag === '1') {
    //         toast.success(`We have ${capName} Capacitor in stock. Please contact us to purchase.`, {
    //             toastId: 'product-flag-toast'
    //         });
    //     }

    //     axios.get(`${BASE_URL}/site-settings`)
    //     .then(res => {
    //         if (res.data.status === 200 && res.data.data) {
    //             const data = res.data.data;
    //             setContactInfo({
    //                 address: data.site_address?.replace(/\r\n/g, ', ') || '',
    //                 phone: data.site_phone_number || '',
    //                 email: data.site_email || ''
    //             });
    //         }
    //     })
    //     .catch(err => {
    //         console.error("Failed to fetch contact info:", err);
    //     });
    // }, [productFlag]);

    useEffect(() => {
        if (productFlag === '1') {
            toast.success(`We have ${capName} Capacitor in stock. Please contact us to purchase.`, {
                toastId: 'product-flag-toast'
            });
        }

        setLoading(true);
        axios.get(`${BASE_URL}/site-settings`)
            .then(res => {
                if (res.data.status === 200 && res.data.data) {
                    const data = res.data.data;
                    setContactInfo({
                        address: data.site_address?.replace(/\r\n/g, ', ') || '',
                        phone: data.site_phone_number || '',
                        email: data.site_email || ''
                    });
                }
            })
            .catch(err => {
                console.error("Failed to fetch contact info:", err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [productFlag, capName]);

    const handleChange = (e) => {
        const { id, value } = e.target;

        // Clean phone input
        if (id === 'phone') {
            if (value && (!/^\d*$/.test(value) || value.length > 10)) return;
        }

        setFormData((prev) => ({ ...prev, [id]: value }));
        setError(''); // Clear error on change
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { name, email, phone, message } = formData;

        // One-by-one validation
        if (!name.trim()) {
            setError("Name is required.");
            return;
        }
        if (!email.trim()) {
            setError("Email is required.");
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
        if (!emailRegex.test(email)) {
            setError("Please enter a valid email address.");
            return;
        }
        if (!phone.trim()) {
            setError("Phone is required.");
            return;
        }
        if (!/^\d+$/.test(phone)) {
            setError("Phone number must contain only digits.");
            return;
        }
        if (phone.length < 6 || phone.length > 10) {
            setError("Phone number must be between 6 and 10 digits.");
            return;
        }
        if (!message.trim()) {
            setError("Message is required.");
            return;
        }

        setIsSubmitting(true);
        setError('');

        try {
            const res = await axios.post(`${BASE_URL}/contact-us-send-mail`, formData);
            if (res.data.responseCode === 200) {
                toast.success("Successfully Submitted !");
                setFormData({ name: '', email: '', phone: '', message: '' });
            } else {
                toast.error(res.data.responseMessage);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
            {loading && <LoaderOverlay />}
            <Header />
            <section className="contact-section">
                <div className="container">
                    <div className="row justify-content-center">
                        {/* Contact Info */}
                        <div className="col-md-6">
                            <div className="contact-info">
                                <h2>Feel free to contact us</h2>
                            </div>
                            <div className="contact-detail">
                                {/* <h3>Address</h3>
                                <p className="address">{contactInfo.address}</p> */}
                                <p>
                                    <strong>Call Us:</strong>{" "}
                                    <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
                                </p>
                                <p>
                                    <strong>Mail Us:</strong>{" "}
                                    <a href={`mailto:${contactInfo.email}`}>{contactInfo.email}</a>
                                </p>
                            </div>
                        </div>

                        {/* Contact Form */}
                        <div className="col-md-6">
                            <div className="contact-box">
                                <h2 className="contact-header">Email Us</h2>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name <span className="text-danger">*</span></label>
                                        <input type="text" className="form-control" id="name" value={formData.name} onChange={handleChange} placeholder="Enter your name" />
                                        {error === 'Name is required.' && <div className="text-danger small mt-1">{error}</div>}
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email <span className="text-danger">*</span></label>
                                        <input type="email" className="form-control" id="email" value={formData.email} onChange={handleChange} placeholder="Enter your email" />
                                        {(error === 'Email is required.' || error === 'Please enter a valid email address.') && <div className="text-danger small mt-1">{error}</div>}
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">Phone <span className="text-danger">*</span></label>
                                        <input type="tel" className="form-control" id="phone" value={formData.phone} onChange={handleChange} placeholder="Enter your phone" />
                                        {(error === 'Phone is required.' || error.includes('Phone number')) && <div className="text-danger small mt-1">{error}</div>}
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="message" className="form-label">Message <span className="text-danger">*</span></label>
                                        <textarea className="form-control" id="message" rows="5" value={formData.message} onChange={handleChange} placeholder="Type your message here"></textarea>
                                        {error === 'Message is required.' && <div className="text-danger small mt-1">{error}</div>}
                                    </div>
                                    <div className="text-center">
                                        <button type="submit" className="btn btn-contact" disabled={isSubmitting}>
                                            {isSubmitting ? "Sending Message..." : "Send Message"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default ContactUs;
